import { observer } from 'mobx-react';
import { FC } from 'react';

import { useDependencies } from '@servicetitan/react-ioc';
import { TableCellProps } from '@servicetitan/table';
import { Switch } from '@servicetitan/anvil2';

import { GlobalOptOutData } from '../types/global-opt-out-data';
import { GlobalOptOutStore } from '../stores/global-opt-out.store';

export const OptInToggleCell: FC<TableCellProps<GlobalOptOutData>> = observer(({ dataItem }) => {
    const [store] = useDependencies(GlobalOptOutStore);

    const handleToggle = async (checked: boolean) => {
        await store.updateOptInStatus(dataItem, checked);
    };

    return (
        <td className="ta-right">
            <Switch
                label="Opt In"
                checked={dataItem.optedIn}
                onChange={(_, state) => {
                    handleToggle(state.checked);
                }}
            />
        </td>
    );
});
